// @flow

import styled from "styled-components"
const Spacer = styled.div`
  width: ${ ( { size = 1 } ) => size * 8 }px;
  height: ${ ( { size = 1 } ) => size * 8 }px;
`

export default Spacer



// WEBPACK FOOTER //
// ./src/components/Spacer.jsx